<template>
    <div class="about container" id="million-bit-about">
        <h3>About</h3>
        <p>
            Welcome to the Million Bit Homepage, where nostalgia meets blockchain innovation! Inspired by the original Million Dollar Homepage, we've brought the fun to Ethereum on Base for Onchain Summer.
            <br /><br />
            Be forever immortalized on the blockchain. Use ETH to upload your image and a link, to secure your spot on the homepage. At the end of onchain summer, the resulting image will be minted.
            <br /><br />
            Share your contribution and make sure to join our community on <a v-bind:href="appData().telegram" target="_blank">Telegram</a> and <a v-bind:href="appData().twitter" target="_blank">Twitter</a> for updates.
        </p>
        <hr />
        <h3>Roadmap</h3>
        <ul>
            <li>✅ Homepage launch [done]</li>
            <li>✅ Affiliate program [done]</li>
            <li>✅ NFT launch to pixel owners [done]</li>
            <li>⏳ Community building (ongoing)</li>
            <li>🔜 Token launch (coming soon)</li>
        </ul>
    </div>
  </template>
  
  <script>
  export default {
    name: 'about',
    data () {
      return {
        
      }
    },
    inject: ['updateAppRoute', 'appData', 'postToLambda'],
    created: function () {
      this.updateAppRoute('about');
    }
  }
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped>
    #million-bit-about {
      background: #fff !important;
      padding: 20px;
      text-align: left;
    }
    #million-bit-about ul {
      list-style: none;
    }
  </style>
  


// WEBPACK FOOTER //
// src/components/About.vue?6a060a48